export const getLeagueSdkErrorCode = (error: unknown): number | undefined => {
  try {
    return JSON.parse((error as Error).message)?.info?.code;
  } catch {
    return undefined;
  }
};
